module.exports = __webpack_public_path__ + "img/Vulturul_bicefal_al_Rusiei_si_stemele_Moldovei_si_Tarii_Romanesti.6d1b38a6.jpg";